// The privileged-decision audit record (data-model.md "audit_log").
//
// Append-only; identifiers and reason only, NO PII, and NO secret value ever appears
// (00-architecture invariant 6, data-model.md). The `cost_eur` column on the table is
// admin-visible only and is deliberately ABSENT from this tenant-facing type
// (invariant 8) - cost lives on the RunLedgerEntry admin port instead.
import { z } from "zod";
import { AppId, AccountId, AuditLogId } from "../ids.js";
import { Timestamp } from "./common.js";
import { AuditActor } from "./enums.js";
export const AuditLogEntry = z.object({
    id: AuditLogId,
    accountId: AccountId,
    actor: AuditActor,
    /** What happened, as a stable identifier + reason (no PII, no secret material). */
    action: z.string().trim().min(1),
    appId: AppId.nullable(),
    /** The outcome of the decision (e.g. "allowed" / "denied"). */
    result: z.string().trim().min(1),
    createdAt: Timestamp,
});
//# sourceMappingURL=audit.js.map